export default __webpack_public_path__ + "cd199915303486c68d44cc647f2839ed.svg";